import instance from "../config/axios";
import { base_apis,url } from "../config/url";

export const termsNConditionPage = () => {
    return instance.post(`${base_apis.page}/terms`).then((res) => {
        return res;
      });
};
export const privacyPolicyPage = () => {
    return instance.post(`${base_apis.page}/privacy-policy`).then((res) => {
        return res;
      });
};

//fetch all lanaguage list
export const getAllLanaguageList = () => {
  return instance.post(`${url.SAAS_API_URL}language/get`).then((res) => {
      return res;
    });
};

//get fav lanaguage
export const getFavLanguage = () => {
  return instance.post(`${base_apis.account}/getLanguage`).then((res) => {
      return res;
    });
};

// update fav language
export const updateFavLanguage = (data) => {
  return instance.post(`${base_apis.account}/update-language`,data).then((res) => {
      return res;
    });
};
